module.exports = __webpack_public_path__ + "img/MenuClose.2c1bce34.svg";